import { render, staticRenderFns } from "./wtAudioAsset.component.vue?vue&type=template&id=40aaf635&scoped=true&"
import script from "./wtAudioAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtAudioAsset.component.vue?vue&type=script&lang=js&"
import style0 from "./wtAudioAsset.component.vue?vue&type=style&index=0&id=40aaf635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aaf635",
  null
  
)

export default component.exports